export const stateKeys = {
  all: ['state'] as const,
  stateConfig: () => [...stateKeys.all, 'stateConfig'] as const,
  stateConfigPoller: () => [...stateKeys.all, 'stateConfigPoller'] as const,
} as const
